import firebase from 'firebase';

const firebaseConfig = {
	apiKey: 'AIzaSyDsTtrtKdaxZKP7am_RzxApfET4csUHJ78',
	authDomain: 'goodest-merch.firebaseapp.com',
	databaseURL: 'https://goodest-merch.firebaseio.com',
	projectId: 'goodest-merch',
	storageBucket: '',
	messagingSenderId: '94657170217',
	appId: '1:94657170217:web:02dee623c9d34d0b178538'
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
